<template>
  <div class="px-2">
    <div class="flex items-center justify-start py-2">
      <div class="w-1/3">
        <!-- <div class="input-group border bg-white rounded-lg border-gray-300">
          <span class="input-group-text bg-white border-0 radius-10 font-size-20 cursor-pointer">
            <i class="fa fa-search"></i>
          </span>
          <input type="search" v-model="searchInput" class="form-control bg-white h-10 mr-2"
            :placeholder="$t('schedule_page.lbl_msg_search')" />
        </div>-->
      </div>
    </div>
    <div v-if="showBeingExamination && beingExamination" class="flex flex-wrap -mx-2">
      <div
        v-for="(item, index) in beingExamination"
        :key="item.id"
        :class="
          index === beingExamination.length - 1 &&
          beingExamination.length % 2 !== 0
            ? 'w-full'
            : 'w-1/2'
        "
        class="px-2 text-2xl"
      >
        <div
          class="border-2 border-solid border-gray-200 hover:bg-gray-50 transition-all duration-200 text-center rounded-md mb-2"
          @click="rowClickHandler(item)"
        >
          <div
            @click.stop
            class="flex justify-center relative bg-gray-200 px-2 py-1 uppercase font-medium"
          >
            <span class="text-sm">{{ item.consulting_room.name }}</span>
            <div
              class="absolute right-2 top-1/2 text-xs font-normal normal-case"
              style="transform: translateY(-50%)"
            >
              <el-dropdown @command="handleUpdateStatus">
                <span class="el-dropdown-link">
                  <span>{{ $t("Sửa đổi") }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="{
                      record: item,
                      status: EXAMINATION_STATUS.CODE.WAITING,
                    }"
                  >
                    <span>{{ $t("Chờ khám") }}</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="{
                      record: item,
                      status: EXAMINATION_STATUS.CODE.WAITING_READ_RESULT,
                    }"
                  >
                    <span>{{ $t("Chờ đọc kết quả") }}</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="{
                      record: item,
                      status: EXAMINATION_STATUS.CODE.DONE,
                    }"
                  >
                    <span>{{ $t("Kết thúc khám") }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="cursor-pointer">
            <div v-if="item.person" class="p-3">
              <span>{{ item.person.name }}</span>
              <span class="mx-1" :class="beingExamination.length > 1 ? 'hidden' : ''">-</span>
              <span :class="beingExamination.length > 1 ? 'block text-xl mt-1' : ''">
                {{
                `${appUtils.formatDate(
                item.person.birthday
                )} (${mdtUtils.getAges(new Date(item.person.birthday))})`
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2">
      <audio id="callPatient" ref="audioRef" src />
      <div class="mb-2 hodo-table table-responsive">
        <table class="w-full">
          <thead>
            <tr>
              <td
                class="bg-gray-200 font-bold uppercase text-center"
                v-for="(field, index) in fields"
                :key="index"
              >
                <span>{{ field.label }}</span>
              </td>
            </tr>
          </thead>
          <tbody>
            <template v-if="itemsProvider.length">
              <tr
                @click="rowClickHandler(row)"
                class="cursor-pointer hover:bg-gray-50 transition-all duration-200"
                v-for="(row, index) in itemsProvider"
                :key="index"
              >
                <td v-for="(field, idx) in fields" :key="idx">
                  <template v-if="field.key === 'person.name'">
                    <div class="font-medium">{{ row.person && row.person.name }}</div>
                    <div v-if="row.person && row.person.birthday">
                      {{ appUtils.formatDate(row.person.birthday) }} ({{
                      mdtUtils.getAges(new Date(row.person.birthday))
                      }})
                    </div>
                  </template>
                  <template v-else-if="field.key === 'method'">
                    <div class="flex items-center justify-center">
                      <div class="w-7 text-center">
                        <i
                          v-if="
                            row.method ===
                            APPOINTMENT_METHOD_STATUS.CODE.OFFLINE
                          "
                          class="el-icon-school text-2xl txt-pri"
                        />
                        <i v-else class="el-icon-video-camera text-2xl txt-pri" />
                      </div>
                      <div class style="color: #20409b">{{ getMethodStatus(row.method) }}</div>
                    </div>
                  </template>
                  <template v-else-if="field.key === 'invoice.status'">
                    <div class="text-center" v-html="renderPaymentStates({ item: row })" />
                  </template>
                  <template v-else-if="field.key === 'status'">
                    <template
                      v-if="
                        tabActive ===
                        EXAMINATION_STATUS.CODE.WAITING_READ_RESULT
                      "
                    >
                      <div class="text-center" :set="(status = getStatusWaitingReadResult(row))">
                        <span :class="status.class">{{ status.text }}</span>
                        <span class="italic text-xs ml-1">
                          {{
                          status.total
                          }}
                        </span>
                      </div>
                    </template>
                    <template v-else-if="tabActive === EXAMINATION_STATUS.CODE.DONE">
                      <div class="text-center" :set="(status = getStatusExaminationResult(row))">
                        <span class="block" :class="status.class">
                          {{
                          status.text
                          }}
                        </span>
                        <span class="italic text-xs">{{ status.total }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-center" :set="(status = getApptStatus(row.status))">
                        <span :class="status.class">{{ status.text }}</span>
                      </div>
                    </template>
                  </template>
                  <template v-else-if="field.key === 'actions'">
                    <div
                      @click.stop
                      class="flex items-start justify-center whitespace-nowrap text-xs -mx-1"
                    >
                      <div>
                        <button
                          :disabled="isLoading"
                          @click="handleCallPatient(row)"
                          type="button"
                          :class="
                            isLoading
                              ? 'disabled cursor-not-allowed'
                              : 'hover:bg-blue-600'
                          "
                          class="text-white border-0 outline-none focus:outline-none bg-blue-800 rounded mx-1 px-2 py-2 transition-all duration-200"
                        >
                          <span>{{ $t("Gọi vào") }}</span>
                        </button>
                        <div :id="`playCall-${row.id}`"></div>
                        <span
                          class="block text-xs text-center"
                          v-if="row.recall"
                        >(Lần {{ row.recall }})</span>
                      </div>
                      <button
                        v-if="
                          row.status !==
                          EXAMINATION_STATUS.CODE.WAITING_READ_RESULT
                        "
                        type="button"
                        :disabled="isLoading"
                        @click="handleStartExamination(row)"
                        :class="
                          isLoading
                            ? 'disabled cursor-not-allowed'
                            : 'hover:bg-green-700'
                        "
                        class="text-white border-0 outline-none focus:outline-none bg-green-800 rounded mx-1 px-2 py-2 transition-all duration-200"
                      >
                        <span>{{ $t("Bắt đầu") }}</span>
                      </button>
                      <button
                        v-if="
                          row.status ===
                          EXAMINATION_STATUS.CODE.WAITING_READ_RESULT
                        "
                        type="button"
                        :disabled="isLoading"
                        @click="handleStartExamination(row)"
                        :class="
                          isLoading
                            ? 'disabled cursor-not-allowed'
                            : 'hover:bg-green-700'
                        "
                        class="text-white border-0 outline-none focus:outline-none bg-green-800 rounded mx-1 px-2 py-2 transition-all duration-200"
                      >
                        <span>{{ $t("Đọc KQ") }}</span>
                      </button>
                      <button
                        :disabled="isLoading"
                        @click="cancelPatientVisit(row)"
                        v-if="
                          row.status === EXAMINATION_STATUS.CODE.WAITING ||
                          row.status === EXAMINATION_STATUS.CODE.NEXT_CALL
                        "
                        type="button"
                        :class="
                          isLoading
                            ? 'disabled cursor-not-allowed'
                            : 'hover:bg-red-700'
                        "
                        class="text-white border-0 outline-none focus:outline-none bg-red-800 rounded mx-1 px-2 py-2 transition-all duration-200"
                      >
                        <span>{{ $t("Bỏ lượt") }}</span>
                      </button>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center">{{ formatterRecord(row, field)[field.key] }}</div>
                  </template>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td :colspan="fields.length">
                <div class="text-center py-3">{{ $t("Không có thông tin khám") }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <b-table id="waiting-examination-table" hover responsive sort-icon-right show-empty
          :empty-text="$t('Không tìm thấy dữ liệu')" head-variant="light" :fields="fields" :items="itemsProvider"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :per-page="pagination.perPage"
          :current-page="pagination.currentPage" @row-clicked="rowClickHandler">
          <template #cell(start_time)="data">
            <div class="font-medium">
              <span>
                {{ appUtils.formatTime(data.item.start_time || new Date()) }}
              </span>
              <span>:</span>
              <span>
                {{ appUtils.formatTime(data.item.end_time || new Date()) }}
              </span>
            </div>
            <div>
              {{ appUtils.formatDate(data.item.start_time || new Date()) }}
            </div>
          </template>
<template #cell(person.name)="data">
            <div class="font-medium">
              {{ data.item.person && data.item.person.name }}
            </div>
            <div v-if="data.item.person && data.item.person.birthday">
              {{ appUtils.formatDate(data.item.person.birthday) }} ({{
                mdtUtils.getAges(new Date(data.item.person.birthday))
              }})
            </div>
          </template>
<template #cell(method)="data">
            <div class="flex items-center">
              <div class="w-7 text-center">
                <i v-if="
                  data.item.method === APPOINTMENT_METHOD_STATUS.CODE.OFFLINE
                " class="el-icon-school text-2xl txt-pri" />
                <i v-else class="el-icon-video-camera text-2xl txt-pri" />
              </div>
              <div class style="color: #20409b">
                {{ getMethodStatus(data.item.method) }}
              </div>
            </div>
          </template>
<template #cell(invoice.status)="data">
            <div v-html="renderPaymentStates(data)" />
          </template>
<template #cell(status)="data">
            <template v-if="tabActive === EXAMINATION_STATUS.CODE.WAITING_READ_RESULT">
              <div :set="(status = getStatusWaitingReadResult(data.item))">
                <span :class="status.class">{{ status.text }}</span>
              </div>
            </template>
<template v-else-if="tabActive === EXAMINATION_STATUS.CODE.DONE">
              <div :set="(status = getStatusExaminationResult(data.item))">
                <span class="block" :class="status.class">
                  {{ status.text }}
                </span>
                <span class="italic text-xs">{{ status.total }}</span>
              </div>
            </template>
<template v-else>
              <div :set="(status = getApptStatus(data.item.status))">
                <span :class="status.class">{{ status.text }}</span>
              </div>
            </template>
</template>
<template #cell(actions)="data" @click.stop>
            <div @click.stop class="flex items-start whitespace-nowrap text-xs -mx-1">
              <div>
                <button :disabled="isLoading" @click="handleCallPatient(data.item)" type="button" :class="isLoading
                  ? 'disabled cursor-not-allowed'
                  : 'hover:bg-blue-600'
                  "
                  class="text-white border-0 outline-none focus:outline-none bg-blue-800 rounded mx-1 px-2 py-2 transition-all duration-200">
                  <span>{{ $t("Gọi vào") }}</span>
                </button>
                <span class="block text-xs text-center" v-if="data.item.recall">(Lần {{ data.item.recall }})</span>
              </div>
              <button v-if="
                data.item.status !==
                EXAMINATION_STATUS.CODE.WAITING_READ_RESULT
              " type="button" :disabled="isLoading" @click="handleStartExamination(data.item)" :class="isLoading
                ? 'disabled cursor-not-allowed'
                : 'hover:bg-green-700'
                "
                class="text-white border-0 outline-none focus:outline-none bg-green-800 rounded mx-1 px-2 py-2 transition-all duration-200">
                <span>{{ $t("Bắt đầu") }}</span>
              </button>
              <button v-if="
                data.item.status ===
                EXAMINATION_STATUS.CODE.WAITING_READ_RESULT
              " type="button" :disabled="isLoading" @click="handleStartExamination(data.item)" :class="isLoading
                ? 'disabled cursor-not-allowed'
                : 'hover:bg-green-700'
                "
                class="text-white border-0 outline-none focus:outline-none bg-green-800 rounded mx-1 px-2 py-2 transition-all duration-200">
                <span>{{ $t("Đọc KQ") }}</span>
              </button>
              <button :disabled="isLoading" @click="cancelPatientVisit(data.item)" v-if="
                data.item.status === EXAMINATION_STATUS.CODE.WAITING ||
                data.item.status === EXAMINATION_STATUS.CODE.NEXT_CALL
              " type="button" :class="isLoading ? 'disabled cursor-not-allowed' : 'hover:bg-red-700'
                "
                class="text-white border-0 outline-none focus:outline-none bg-red-800 rounded mx-1 px-2 py-2 transition-all duration-200">
                <span>{{ $t("Bỏ lượt") }}</span>
              </button>
            </div>
          </template>
        </b-table>-->
      </div>
      <div class="flex justify-end items-center w-full">
        <div v-if="meta && meta.total > pagination.perPage">
          <b-pagination
            aria-controls="schedule-table"
            v-model="pagination.currentPage"
            :total-rows="totalPages"
            :per-page="pagination.perPage"
            size="sm"
            align="right"
            @page-click="handlePageClick"
            first-number
            last-number
            class="hodo-schedule-table m-0"
            prev-class="prev-item border border-gray-200 rounded mx-1"
            next-class="next-item border border-gray-200 rounded mx-1"
            :page-class="'border border-gray-200 rounded mx-1'"
            :ellipsis-class="'border border-gray-200 rounded mx-1'"
          >
            <template #page="{ page, active }">
              <span :class="active ? 'text-white' : 'text-gray-600'">
                {{
                page
                }}
              </span>
            </template>
            <template #prev-text>
              <i class="el-icon-arrow-left text-gray-600" />
            </template>
            <template #next-text>
              <i class="el-icon-arrow-right text-gray-600" />
            </template>
          </b-pagination>
        </div>
        <div class="ml-1">
          <el-dropdown @command="handleSelectedShowRecord">
            <span
              class="block py-1.5 px-2 rounded-lg border bg-white text-gray-900 text-sm"
              role="button"
            >
              <span>{{ pagination.perPage }}</span>
              <span class="mx-1">/</span>
              <span>{{ $t("Trang") }}</span>
              <i class="el-icon-caret-bottom" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="item"
                v-for="(item, index) in listShowRecord"
                :key="index"
              >
                <span>{{ item }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BPagination, BTable } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import appUtils from '../../../utils/appUtils'
import { APPOINTMENT_METHOD_STATUS, APPOINTMENT_STATUS, EXAMINATION_STATUS, INVOICE_STATUS } from '../../../utils/constants'
import mdtUtils from '../../../utils/mdtUtils'

export default {
  name: 'PatientVisitTabContent',
  props: {
    tabActive: {
      type: Number,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    listData: {
      type: Array,
      required: true
    },
    metaData: {
      type: Object
    },
    showBeingExamination: {
      type: Boolean,
      default: false
    },
    beingExaminationData: {
      type: Array
    }
  },
  components: {
    BTable,
    BPagination
  },
  data () {
    return {
      isLoading: false,
      searchInput: '',
      listShowRecord: [10, 20, 50, 100, 200, 500, 1000],
      pagination: {
        perPage: isNaN(Number(this.metaData?.page_size)) ? 0 : Number(this.metaData?.page_size),
        currentPage: isNaN(Number(this.metaData?.page_num)) ? 1 : Number(this.metaData?.page_num)
      },
      sortBy: 'line_number',
      sortDesc: false,
      meta: null,
      totalPages: this.metaData?.total || 0,
      beingExamination: null,
      appUtils,
      mdtUtils,
      APPOINTMENT_STATUS,
      EXAMINATION_STATUS,
      APPOINTMENT_METHOD_STATUS,
      INVOICE_STATUS,
      audioSource: ''
    }
  },
  watch: {
    metaData (data) {
      if (data) {
        this.meta = { ...data }
        this.totalPages = data?.total
        this.pagination.perPage = isNaN(Number(data?.page_size)) ? 0 : Number(data?.page_size)
        this.pagination.currentPage = isNaN(Number(data?.page_num)) ? 1 : Number(data?.page_num)
      } else {
        this.meta = null
        this.totalPages = 0
      }
    },
    beingExaminationData (data) {
      if (data) {
        this.beingExamination = data
      } else {
        this.beingExamination = null
      }
    }
  },
  computed: {
    ...mapGetters({
      listAudio: 'appointmentStore/allAudio'
    }),
    itemsProvider () {
      return this.listData || []
    }
  },
  methods: {
    ...mapActions('appointmentStore', ['callPatientRequest', 'updatePatientVisitByIdRequest', 'addAudioToList']),
    rowClickHandler (record, index) {
      if (record) {
        this.$router.push({
          name: 'PatientVisitDetail',
          params: { id: record.id }
        })
      }
    },
    handleSelectedShowRecord (value) {
      this.pagination.perPage = Number(value)
      this.$emit('onSetLimit', Number(value))
    },
    getApptStatus (stt) {
      switch (stt) {
        case EXAMINATION_STATUS.CODE.WAITING:
          return { class: 'text-yellow-600', text: this.$t('Chờ khám') }
        case EXAMINATION_STATUS.CODE.BEING:
          return { class: 'text-blue-800', text: this.$t('Đang khám') }
        case EXAMINATION_STATUS.CODE.WAITING_RESULT:
          return { class: 'text-yellow-600', text: this.$t('Chờ kết quả') }
        case EXAMINATION_STATUS.CODE.WAITING_READ_RESULT:
          return { class: 'text-yellow-600', text: this.$t('Chờ đọc kết quả') }
        case EXAMINATION_STATUS.CODE.DONE:
          return { class: 'text-green-700', text: this.$t('Đã khám xong') }
        case EXAMINATION_STATUS.CODE.CANCELED:
          return { class: 'text-red-700', text: this.$t('Đã hủy lượt') }
        case EXAMINATION_STATUS.CODE.MISSING:
          return { class: 'text-red-700', text: this.$t('Nhỡ lượt') }
        default:
          return { class: 'text-yellow-600', text: this.$t('Chờ khám') }
      }
    },
    renderPaymentStates (data) {
      switch (Number(data.item?.appt?.invoice?.status)) {
        case INVOICE_STATUS.CODE.PATIENT_PENDING:
          return `<span class="text-red-600">${this.$t('Chưa thanh toán')}</span>`
        case INVOICE_STATUS.CODE.PATIENT_PAID:
          return `<span class="text-yellow-600">${this.$t('Chờ xác nhận')}</span>`
        case INVOICE_STATUS.CODE.DOCTOR_ACCEPT:
          return `<span class="text-green-700">${this.$t('Đã thanh toán')}</span>`
        default:
          return `<span class="text-red-600">${this.$t('Chưa thanh toán')}</span>`
      }
    },
    getMethodStatus (method) {
      const methodStatus = ['', this.$t('schedule_page.lbl_type_workspace'), this.$t('schedule_page.lbl_type_online')]
      return methodStatus[method]
    },
    checkingIndicationFullResult (indication) {
      if (!indication) return

      const listSentResult = indication?.indication_informs?.reduce((total, item) => {
        if (total.includes(item.indication_id)) return total

        total.push(item.indication_id)

        return total
      }, [])

      const totalIndications = indication?.indication_order?.reduce((total, item) => {
        return (total = total + (item.indication?.length || 0))
      }, 0)

      return {
        isNonResult: !indication.indication_informs?.length,
        countSentResults: listSentResult?.length || 0,
        totalIndications
      }
    },
    checkingIndicationStatusResult (patientVisit) {
      let totalIndications = 0

      if (!patientVisit?.indication_order?.length) {
        return {
          countIndicationResult: 0,
          totalIndications
        }
      }

      const countIndicationResult = patientVisit?.indication_order?.reduce((total, item) => {
        if (!item?.indication?.length) return total
        item.indication.forEach(childItem => {
          totalIndications++
          if (childItem?.examination_result?.id) {
            total++
          }
        })

        return total
      }, 0)

      return {
        countIndicationResult,
        totalIndications
      }
    },
    getStatusWaitingReadResult (data) {
      // const indicationOrder = data?.indication_order
      const { countIndicationResult, totalIndications } = this.checkingIndicationStatusResult(data)

      if (!countIndicationResult) {
        return {
          text: this.$t('Chưa có kết quả'),
          class: 'text-yellow-600',
          total: totalIndications ? `(${countIndicationResult} / ${totalIndications})` : ''
        }
      } else {
        return {
          text: this.$t('Đã có kết quả'),
          class: 'text-green-700',
          total: totalIndications ? `(${countIndicationResult} / ${totalIndications})` : ''
        }
      }
    },
    getStatusExaminationResult (data) {
      // const indicationOrder = data?.indication_order
      const { countSentResults, totalIndications } = this.checkingIndicationFullResult(data)

      if (!data.indication_informs?.length) {
        return {
          text: this.$t('Chưa gửi KQ cho bệnh nhân'),
          class: 'text-yellow-600'
        }
      } else {
        return {
          text: this.$t('Đã gửi KQ cho bệnh nhận'),
          class: 'text-green-700',
          total: `${this.$t('Đã gửi')} ${countSentResults} / ${totalIndications}`
        }
      }
    },
    async handleCallPatient (record) {
      const self = this

      if (!record) {
        this.$message({
          type: 'error',
          message: self.$t(`Không tìm thấy thông tin bệnh nhân`)
        })
        return
      }

      try {
        this.isLoading = true
        // let calledPatient = this.listData?.filter((elm) => elm.recall >= 1)
        // const notContainedCurrentCalledPatient = calledPatient.every((obj) => {
        //   return obj.person_id !== record.person_id
        // })
        // if (calledPatient.length > 0 && notContainedCurrentCalledPatient) {
        //   this.$message({
        //     type: 'error',
        //     message: self.$t(`Vẫn còn bệnh nhân đang được gọi.`)
        //   })
        //   this.isLoading = false
        //   return
        // }

        let res = await self.callPatientRequest({
          id: record.id,
          data: {
            recalled_at: self.moment()
          }
        })
        let user = self.$user
        let clinic = self.$globalClinic
        const amplitudeObj = {
          'user id': user && user.id ? user.id : '',
          'patient id': record && record.person_id ? record.person_id : '',
          'patient name': record && record.person && record.person.name ? record.person.name : '',
          'workspace id': clinic && clinic.id ? clinic.id : '',
          'workspace name': clinic && clinic.name ? clinic.name : '',
          'org id': clinic && clinic.org_id ? clinic.org_id : '',
          'org name': clinic && clinic.org_name ? clinic.org_name : '',
          timestamp: self.moment(new Date()).format('HH:mm DD-MM-YYYY')
        }
        self.sendAmplitude('Số lần BS click gọi BN vào', amplitudeObj)
        if (this.tabActive === EXAMINATION_STATUS.CODE.WAITING && record.recall === 0) {
          self.sendAmplitude('Số lượng bệnh nhân Chờ khám mà BS Gọi vào', amplitudeObj)
        }
        if (this.tabActive === EXAMINATION_STATUS.CODE.WAITING_READ_RESULT && record.recall === 0) {
          self.sendAmplitude('Số lượng bệnh nhân Chờ đọc kết quả mà BS Gọi vào', amplitudeObj)
        }
        if (this.tabActive === EXAMINATION_STATUS.CODE.MISSING && record.recall === 0) {
          self.sendAmplitude('Số lượng bệnh nhân Nhỡ lượt mà BS Gọi vào', amplitudeObj)
        }
        // let voiceBase64 = ''
        // let audioSrc = ''

        // if (!self.listAudio.length) {
        //   res = await self.$rf.getRequest('HIDRequest').generateTextToVoice({
        //     input_text: `Xin mời bệnh nhân số ${record?.line_number} vào phòng`
        //   })

        //   if (res) {
        //     voiceBase64 = res?.data?.Voice
        //     // voiceBase64 = `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`
        //     audioSrc = `data:audio/ogg;base64, ${voiceBase64}`
        //     self.addAudioToList({
        //       id: record.id,
        //       audioSrc
        //     })
        //   }
        // } else {
        //   const audioRaw = self.listAudio.find((item) => item.id === record.id)

        //   if (audioRaw) {
        //     voiceBase64 = audioRaw.audioSrc
        //     audioSrc = voiceBase64
        //   } else {
        //     res = await self.$rf.getRequest('HIDRequest').generateTextToVoice({
        //       input_text: `Xin mời bệnh nhân số ${record?.line_number} vào phòng`
        //     })

        //     if (res) {
        //       voiceBase64 = res?.data?.Voice
        //       // voiceBase64 = `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`
        //       audioSrc = `data:audio/ogg;base64, ${voiceBase64}`
        //       self.addAudioToList({
        //         id: record.id,
        //         audioSrc
        //       })
        //     }
        //   }
        // }

        if (res) {
          // const audioEl = document.getElementById(`callPatient`)

          // audioEl.setAttribute('src', audioSrc)
          // audioEl.play().catch(console.warn)

          this.isLoading = false
          self.$message({
            type: 'success',
            message: self.$t(`Bạn đã thực hiện lệnh gọi bệnh nhân`)
          })
          self.$emit('refresh', record.id)
        }
      } catch (error) {
        console.log(error)
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    baseDataUpdate (record) {
      return {
        appt_id: record.appt_id,
        clinic_id: record.clinic_id,
        doctor_id: record.doctor.id,
        cr_id: record.cr_id,
        person_id: record.person_id,
        start_time: window
          .moment(record.start_time)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        end_time: record.end_time,
        checkin_time: record.checkin_time,
        cancel_reason: ''
      }
    },
    async baseHandle ({ record, status }) {
      const self = this

      if (!record || !status) {
        self.$message({
          type: 'error',
          message: self.$t(`Không tìm thấy thông tin bệnh nhân`)
        })
        return
      }

      const data = self.baseDataUpdate(record)

      await this.updatePatientVisitByIdRequest({
        id: record.id,
        data: {
          ...data,
          status: status
        },
        isDetail: false
      })
    },
    async handleUpdateStatus (command) {
      const self = this
      let messageTitle = 'Thay đổi trạng thái của bệnh nhân'
      let message = 'Bạn chắc chắn muốn thay đổi trạng thái?'

      self
        .$confirm(self.$t(message), self.$t(messageTitle))
        .then(async _ => {
          try {
            self.isLoading = true
            await self.baseHandle({
              record: command.record,
              status: command.status
            })
          } catch (error) {
            console.log(error)
            self.isLoading = false
          } finally {
            self.isLoading = false
            self.$emit('refresh')
          }
        })
        .catch(_ => {})
    },
    async handleStartExamination (record) {
      const self = this

      if (self.beingExamination?.length) {
        const _confirm = await self
          .$confirm(self.$t('Có bệnh nhận đang được khám, <br/>bạn muốn bắt đầu khám cho bệnh nhận mới?'), self.$t('Cảnh báo'), {
            dangerouslyUseHTMLString: true
          })
          .catch(_ => {})

        if (!_confirm) return
      }

      try {
        self.isLoading = true
        await self.baseHandle({
          record,
          status: EXAMINATION_STATUS.CODE.BEING
        })
      } catch (error) {
        console.log(error)
        self.isLoading = false
      } finally {
        self.isLoading = false
        self.$message({
          type: 'success',
          message: self.$t('Bắt đầu khám cho bệnh nhân')
        })
        self.$emit('refresh')
        self.rowClickHandler(record)
      }
    },
    async cancelPatientVisit (record) {
      const self = this

      try {
        self.isLoading = true
        await self.baseHandle({
          record,
          status: EXAMINATION_STATUS.CODE.MISSING
        })
      } catch (error) {
        console.log(error)
        self.isLoading = false
      } finally {
        self.isLoading = false
        self.$message({
          type: 'success',
          message: self.$t('Bỏ lượt khám thành công!')
        })
        self.$emit('refresh')
      }
    },
    handlePageClick (event, page) {
      event.preventDefault()
      const data = {
        page,
        status: this.tabActive
      }
      this.$emit('handlePageClick', data)
    },
    formatterRecord (row, field) {
      const mappedRecord = {}
      let value = row
      const keys = field.key.split('.')

      keys.forEach(key => {
        if (value && value.hasOwnProperty(key)) {
          value = value[key]
        } else {
          value = null
        }
      })

      mappedRecord[field.key] = value
      return mappedRecord
    }
  }
}
</script>
